import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import {
  Alert,
  Button,
  Grid,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Box, Container } from '@mui/system';

import DynamicBreadcrumbs from '@/components/nav/Breadcrumb';
import ResourcesRightSidebar from '@/components/nav/ResourcesRightSidebar';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const Form1120sSchD = () => {
  return (
    <AppLayout
      meta={
        <Meta
          title="Schedule D (Form 1120-S) Capital Gains | TaxZerone"
          description="Learn how S corporations report capital gains, losses, and built-in gains using IRS Form 1120-S Schedule D. File accurately and easily with TaxZerone."
          keywords=""
          canonical="resources/business-tax/form-1120s-schedule-d/"
          ogType="article"
          jsonLdPricing="179.99"
          jsonLdAggregateRatingValue="4.97"
          jsonLdAggregateRatingCount="1658"
        />
      }
    >
      <Container maxWidth="lg" sx={{ textAlign: 'center' }}>
        <Typography
          variant="h1"
          sx={{
            fontSize: { lg: 40, md: 36, sm: 32, xs: 24 },
            fontWeight: 600,
            mb: 5,
            mt: 5,
            textAlign: 'center',
          }}
        >
          IRS Form 1120-S{' '}
          <span className="highlight-container">
            <span className="highlight">Schedule D</span>
          </span>{' '}
          Capital Gains and Losses
        </Typography>
        {/* <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            mt: 1,
            mb: 2,
          }}
        >
          E-File your IRS <span style={{ fontWeight: 600 }}> Form 1120-S</span>{' '}
          for the 2024 tax year by{' '}
          <span style={{ fontWeight: 600 }}>March 17, 2025,</span> to meet
          federal S
          <Hidden smDown>
            {' '}
            <br />
          </Hidden>{' '}
          corporation filing deadlines and avoid potential penalties.
        </Typography>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Button
            variant="contained"
            className="btn-primary medium"
            sx={{
              fontSize: {
                xs: '16px !important',
                sm: '18px !important',
                lg: '24px !important',
              },
              transition: 'all 0.3s ease 0s',
              '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
            }}
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=1120sduedates`}
          >
            E-file Now!
          </Button> */}
        {/* </Box> */}
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          py: 5,
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        mt={0}
      >
        <Container maxWidth="lg" sx={{ mb: 0 }}>
          <DynamicBreadcrumbs />
          <Grid
            container
            spacing={0}
            rowSpacing={0}
            m={0}
            sx={{ flexDirection: 'row-reverse' }}
          >
            <Grid
              size={{ xs: 12, md: 3.5, sm: 4.5 }}
              sx={{ display: { xs: 'none', sm: 'block' } }}
            >
              <ResourcesRightSidebar />
            </Grid>
            <Grid size={{ xs: 12, md: 8.5, sm: 7.5 }}>
              <Paper
                variant="outlined"
                sx={{
                  border: '1px solid #ccc',
                  p: 3,
                  px: 3,
                  textAlign: 'left',
                  mb: 0,
                  minHeight: '100%',
                }}
              >
                <Box
                  component="article"
                  itemScope
                  itemType="https://schema.org/Article"
                  sx={{
                    p: 3,
                    px: 3,
                    backgroundColor: '#f0f5f8',
                    borderLeft: '5px solid #01456c',
                    mb: 4,
                    borderRadius: 3,
                    position: 'relative',
                  }}
                >
                  <link
                    itemProp="mainEntityOfPage"
                    href="https://www.taxzerone.com/resources/business-tax/form-1120s-schedule-d/"
                  />
                  {/* Article requires an image */}
                  <div
                    itemProp="image"
                    itemScope
                    itemType="https://schema.org/ImageObject"
                    style={{ display: 'none' }}
                  >
                    <link
                      itemProp="url"
                      href="https://www.taxzerone.com/assets/images/logo.webp"
                    />
                    <data itemProp="width" value="380" />
                    <data itemProp="height" value="124" />
                  </div>
                  <Box
                    sx={{
                      display: 'grid',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      textAlign: 'left',
                      mb: 2,
                    }}
                  >
                    <Typography variant="body2">
                      Last updated:{' '}
                      <time
                        itemProp="datePublished"
                        dateTime="2026-08-25T09:00:00-05:00"
                      >
                        Aug 25, 2026
                      </time>
                      <time
                        itemProp="dateModified"
                        dateTime="2026-08-25T09:00:00-05:00"
                        style={{ display: 'none' }}
                      >
                        Aug 25, 2026
                      </time>
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 600 }}
                      itemProp="author"
                      itemScope
                      itemType="https://schema.org/Person"
                    >
                      -by{' '}
                      <span itemProp="name">
                        <a
                          itemProp="url"
                          href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}`}
                          style={{
                            color: 'inherit',
                            textDecoration: 'none',
                          }}
                        >
                          Nikhil Chowdary
                        </a>
                      </span>{' '}
                      | TaxZerone
                    </Typography>
                  </Box>
                  <Typography
                    component="h2"
                    itemProp="headline"
                    variant="h4"
                    sx={{
                      fontWeight: 600,
                      mb: 0.8,
                      fontSize: { md: 20, sm: 18, xs: 16 },
                      color: '#01456c',
                      fontStyle: 'italic',
                    }}
                  >
                    Schedule D (Form 1120-S) at a Glance
                  </Typography>

                  <Box
                    component="ul"
                    itemProp="articleBody"
                    sx={{
                      mb: 0,
                      pl: 0,
                      listStyle: 'none',
                      '& li': { mb: 1.6, position: 'relative', pl: 3 },
                      '& li::before': {
                        content: '"★"',
                        position: 'absolute',
                        left: 0,
                        top: '-2px',
                        color: '#01456c',
                        fontSize: '18px',
                      },
                    }}
                  >
                    <li>
                      <span>
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Understand the purpose of Schedule D (Form 1120-S)
                        </strong>{' '}
                        and how S corporations report capital gains, capital
                        losses, and built-in gains from the sale or exchange of
                        capital assets.
                      </span>
                    </li>
                    <li>
                      <span>
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Learn who must file Schedule D
                        </strong>{' '}
                        and when it is required for reporting transactions
                        involving stocks, bonds, real estate, digital assets,
                        installment sales, and built-in gains tax.
                      </span>
                    </li>
                    <li>
                      <span>
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Explore how to complete Schedule D step by step,
                        </strong>{' '}
                        including reporting short-term and long-term capital
                        gains and losses, Qualified Opportunity Fund (QOF)
                        transactions, and built-in gains tax calculations.
                      </span>
                    </li>
                    <li>
                      <span>
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Understand how Schedule D works with Form 8949, Form
                          1099-DA, Form 4797, Form 6252, Schedule K, and
                          Schedule K-1
                        </strong>{' '}
                        to ensure accurate reporting of capital transactions and
                        shareholder allocations.
                      </span>
                    </li>
                  </Box>
                </Box>
                <Stack
                  direction={{ xs: 'column-reverse', md: 'row' }}
                  spacing={{ xs: 1, sm: 2, md: 3 }}
                  sx={{ mb: 0 }}
                >
                  <Box>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                      When an S corporation sells or exchanges capital assets
                      such as stocks, bonds, or property, the IRS requires those
                      transactions to be reported on{' '}
                      <Link
                        href="https://www.irs.gov/pub/irs-pdf/f1120ssd.pdf"
                        target="_blank"
                        sx={{ color: '#0202ff' }}
                      >
                        Schedule D
                      </Link>{' '}
                      (
                      <Link
                        href="https://www.irs.gov/pub/irs-pdf/f1120ssd.pdf"
                        target="_blank"
                        sx={{ color: '#0202ff' }}
                      >
                        Form 1120-S
                      </Link>
                      ). This schedule summarizes the corporation’s{' '}
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        short-term and long-term capital gains and losses,
                      </span>{' '}
                      and helps calculate any{' '}
                      <span style={{ fontWeight: 600 }}>
                        built-in gains tax
                      </span>{' '}
                      that may apply.
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                      Properly completing Schedule D ensures that gains or
                      losses are passed through to shareholders accurately and
                      that the corporation remains compliant with IRS reporting
                      requirements.
                    </Typography>

                    <Typography variant="body1" sx={{ mb: 1 }}>
                      With{' '}
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Schedule D (Form 1120-S)
                      </span>{' '}
                      S corporations can:
                    </Typography>
                    <Box component="ul" sx={{ '& li': { mb: 1.5 }, mb: 1 }}>
                      <li>Report all capital asset transactions</li>
                      <li>
                        Distinguish between short-term and long-term gains{' '}
                      </li>
                      <li>
                        Calculate and report built-in gains tax, if applicable
                      </li>
                      <li>
                        Transfer results to{' '}
                        <span style={{ fontWeight: 600 }}> Schedule K</span> and
                        <span style={{ fontWeight: 600 }}>
                          each shareholder’s{' '}
                          <Link
                            href="https://www.irs.gov/pub/irs-pdf/f1120ssk.pdf"
                            target="_blank"
                            sx={{ color: '#0202ff' }}
                          >
                            {' '}
                            Schedule K-1
                          </Link>
                        </span>{' '}
                      </li>
                    </Box>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                      Accurate reporting through Schedule D is essential for IRS
                      compliance and for correctly distributing income,
                      deductions, and credits to shareholders.
                    </Typography>
                  </Box>
                  <Box
                    sx={{ mb: 1, textAlign: { xs: 'center', md: 'left' } }}
                  />
                </Stack>
                <Box
                  sx={{
                    pt: 0,
                  }}
                >
                  <Typography variant="body1" sx={{ mb: 0.5 }}>
                    <b>Table of Contents</b>
                  </Typography>
                  <List
                    sx={{ mb: 5, border: '1px solid #ccc', borderRadius: 2 }}
                  >
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#whatis" sx={{ color: '#0202ff' }}>
                          What’s New for Schedule D (Form 1120-S) - Digital
                          Assets
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#whatisirs" sx={{ color: '#0202ff' }}>
                          What Is IRS Form 1120-S Schedule D?
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#whyschd" sx={{ color: '#0202ff' }}>
                          Why Schedule D Matters
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#whomust" sx={{ color: '#0202ff' }}>
                          Who Must File Schedule D (Form 1120-S)?
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#step" sx={{ color: '#0202ff' }}>
                          Step-by-Step Breakdown of Schedule D (Form 1120-S)
                        </Link>
                        <List sx={{ pb: 0 }}>
                          <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                            <ListItemIcon
                              sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                            >
                              <DoubleArrowIcon />
                            </ListItemIcon>
                            <ListItemText>
                              <Link href="#part1" sx={{ color: '#0202ff' }}>
                                Part I: Short-Term Capital Gain and Losses
                              </Link>
                            </ListItemText>
                          </ListItem>
                          <ListItem
                            sx={{ py: 0.5, pb: 0, alignItems: 'flex-start' }}
                          >
                            <ListItemIcon
                              sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                            >
                              <DoubleArrowIcon />
                            </ListItemIcon>
                            <ListItemText>
                              <Link href="#part2" sx={{ color: '#0202ff' }}>
                                Part II: Long-Term Capital Gain and Losses
                              </Link>
                            </ListItemText>
                          </ListItem>
                          <ListItem
                            sx={{ py: 0.5, pb: 0, alignItems: 'flex-start' }}
                          >
                            <ListItemIcon
                              sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                            >
                              <DoubleArrowIcon />
                            </ListItemIcon>
                            <ListItemText>
                              <Link href="#part3" sx={{ color: '#0202ff' }}>
                                Part III: Built-in Gains Tax
                              </Link>
                            </ListItemText>
                          </ListItem>
                        </List>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#filing" sx={{ color: '#0202ff' }}>
                          Filing Deadline for Schedule D
                        </Link>
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#common" sx={{ color: '#0202ff' }}>
                          Common Mistakes to Avoid
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#best" sx={{ color: '#0202ff' }}>
                          Best Practices for Compliance
                        </Link>
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#faqs" sx={{ color: '#0202ff' }}>
                          Frequently Asked Questions (FAQs)
                        </Link>
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 2,
                    scrollMarginTop: 83,
                  }}
                  id="whatis"
                >
                  What’s New for Schedule D (Form 1120-S) — Digital Assets
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Beginning with Tax Year 2025 filings, the IRS has expanded
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Schedule D (Form 1120-S)
                  </span>{' '}
                  to support{' '}
                  <span style={{ fontWeight: 600 }}>
                    digital asset reporting,
                  </span>
                  such as cryptocurrency and other blockchain-based assets.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  The IRS has added{' '}
                  <span style={{ fontWeight: 600 }}>
                    new transaction codes G, H, I, J, K, and L on Schedule D
                    lines 1b, 2, 3, 8b, 9, and 10
                  </span>{' '}
                  to properly classify digital asset sales and exchanges.
                </Typography>
                <Typography variant="body1">
                  If your S corporation traded, sold, or disposed of digital
                  assets during the year, those transactions must now be
                  reported using:
                </Typography>
                <Box component="ul" sx={{ mb: 2, '&  li': { mb: 1.5 } }}>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Form 1099-DA – Digital Asset Proceeds From Broker
                      Transactions
                    </span>
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Form 8949 – Sales and Other Dispositions of Capital
                      Assets{' '}
                    </span>
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Schedule D (Form 1120-S)
                    </span>{' '}
                    using the new digital asset codes{' '}
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  These changes ensure that{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    crypto and digital asset gains or losses
                  </span>{' '}
                  are treated the same way as stocks, securities, and other
                  capital assets for tax purposes.
                </Typography>
                <Typography variant="body1">
                  Failing to use the correct codes may cause:
                </Typography>
                <Box component="ul" sx={{ mb: 3, '& li': { mb: 1.2 } }}>
                  <li>IRS return rejections </li>
                  <li>Mismatched Form 1099-DA records </li>
                  <li>Incorrect shareholder K-1 reporting </li>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 2,
                    scrollMarginTop: 83,
                  }}
                  id="whatisirs"
                >
                  What Is IRS Form 1120-S Schedule D?
                </Typography>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  <span style={{ fontWeight: 600 }}>
                    Schedule D (Form 1120-S)
                  </span>{' '}
                  is used by S corporations to report{' '}
                  <span style={{ fontWeight: 600 }}>
                    capital gains and losses
                  </span>{' '}
                  from sales or exchanges of capital assets. It also determines
                  the{' '}
                  <span style={{ fontWeight: 600 }}>built-in gains tax</span>{' '}
                  under Section 1374 for corporations that were previously C
                  corporations.
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  It consolidates all transactions from{' '}
                  <Link
                    href="https://www.irs.gov/forms-pubs/about-form-8949"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Form 8949
                  </Link>{' '}
                  <span style={{ fontWeight: 600 }}>
                    (Sales and Other Dispositions of Capital Assets)
                  </span>{' '}
                  and helps determine how these gains or losses impact the
                  corporation’s and shareholders’ overall tax obligations.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Common Transactions Reported on Schedule D
                </Typography>
                <Box component="ul" sx={{ mb: 4, '& li': { mb: 1.2 } }}>
                  <li>
                    Sale of stocks, bonds, or mutual funds held for
                    investment{' '}
                  </li>
                  <li>Sale or exchange of real estate or business property </li>
                  <li>
                    Gains or losses reported on{' '}
                    <Link
                      href="https://www.irs.gov/pub/irs-pdf/f4797.pdf"
                      target="_blank"
                      sx={{ color: '#0202ff' }}
                    >
                      {' '}
                      Form 4797
                    </Link>{' '}
                    (transferred here when applicable){' '}
                  </li>
                  <li>
                    Disposition of assets received through installment sales (
                    <Link
                      href="https://www.irs.gov/pub/irs-pdf/f6252.pdf"
                      target="_blank"
                      sx={{ color: '#0202ff' }}
                    >
                      Form 6252
                    </Link>
                    ){' '}
                  </li>
                  <li>
                    Built-in gains from assets held when converting from C
                    corporation to S corporation{' '}
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Add below short paragraph inside your{' '}
                  <span style={{ fontWeight: 600 }}>
                    “Common Transactions Reported on Schedule D”
                  </span>{' '}
                  section:
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Digital asset transactions (cryptocurrency, NFTs, or
                  blockchain-based assets) reported through Form 1099-DA and
                  Form 8949 using the new Schedule D codes G–L
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="whyschd"
                >
                  Why Schedule D Matters
                </Typography>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Accurate Capital Gain Calculation
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  It ensures correct reporting of all capital transactions,
                  helping avoid misclassification between short-term and
                  long-term gains.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Shareholder Transparency
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Since S corporations are pass-through entities, accurate
                  Schedule D reporting ensures shareholders receive correct K-1
                  allocations.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  IRS Compliance
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Omitting or incorrectly reporting gains can trigger IRS
                  notices or audits, especially for built-in gains.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Tax Efficiency
                </Typography>
                <Typography variant="body1" sx={{ mb: 4 }}>
                  Understanding gain classification allows corporations to
                  optimize the timing and structure of asset sales.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="whomust"
                >
                  Who Must File Schedule D (Form 1120-S)?
                </Typography>

                <Typography variant="body1" sx={{ mb: 1 }}>
                  Every <span style={{ fontWeight: 600 }}>S corporation </span>{' '}
                  that has{' '}
                  <span style={{ fontWeight: 600 }}>
                    capital gains, losses, or built-in gains
                  </span>{' '}
                  during the tax year must complete Schedule D and attach it to
                  <Link
                    href="/business-returns/efile-irs-form-1120-s/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Form 1120-S
                  </Link>
                  .
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  You must file Schedule D if your corporation:
                </Typography>
                <Box component="ul" sx={{ mb: 3, '& li': { mb: 1.2 } }}>
                  <li>Sold or exchanged any capital asset</li>
                  <li>
                    Reported capital transactions on{' '}
                    <Link
                      href="https://www.irs.gov/forms-pubs/about-form-8949"
                      target="_blank"
                      sx={{ color: '#0202ff' }}
                    >
                      {' '}
                      Form 8949{' '}
                    </Link>
                  </li>
                  <li>Has carryover capital losses from prior years </li>
                  <li>
                    Owes built-in gains tax under{' '}
                    <span style={{ fontWeight: 600 }}> Section 1374</span>
                  </li>
                  <li>
                    Needs to report capital gains distributed to
                    shareholders{' '}
                  </li>
                </Box>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Related Forms and Their Purpose
                </Typography>
                <Box component="div" sx={{ mb: 2 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Form
                          </TableCell>

                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Purpose
                          </TableCell>
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            When to Use
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell sx={{ fontWeight: 600 }}>
                            <Link
                              href="https://www.irs.gov/forms-pubs/about-form-8949"
                              target="_blank"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              Form 8949
                            </Link>
                          </TableCell>
                          <TableCell>
                            Reports each capital asset transaction in detail
                          </TableCell>
                          <TableCell>
                            When you have multiple sales or exchanges
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell sx={{ fontWeight: 600 }}>
                            <Link
                              href="https://www.irs.gov/pub/irs-pdf/f4797.pdf"
                              target="_blank"
                              sx={{ color: '#0202ff' }}
                            >
                              Form 4797
                            </Link>
                          </TableCell>

                          <TableCell>
                            Reports sale of business property
                          </TableCell>
                          <TableCell>
                            For Section 1231 or depreciation recapture gains
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell sx={{ fontWeight: 600 }}>
                            <Link
                              href="https://www.irs.gov/pub/irs-pdf/f6252.pdf"
                              target="_blank"
                              sx={{ color: '#0202ff' }}
                            >
                              Form 6252
                            </Link>
                          </TableCell>

                          <TableCell>Reports installment sales</TableCell>
                          <TableCell>
                            When payments are received over multiple years
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell sx={{ fontWeight: 600 }}>
                            <Link
                              href="/business-tax/efile-irs-form-1120-s/"
                              sx={{ color: '#0202ff' }}
                            >
                              Form 1120-S
                            </Link>
                          </TableCell>

                          <TableCell>
                            Main S Corporation income tax return
                          </TableCell>
                          <TableCell>Schedule D must be attached</TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell sx={{ fontWeight: 600 }}>
                            <Link
                              href="https://www.irs.gov/pub/irs-pdf/f1120ssk.pdf"
                              target="_blank"
                              sx={{ color: '#0202ff' }}
                            >
                              Schedule K-1 (Form 1120-S)
                            </Link>
                          </TableCell>

                          <TableCell>
                            Reports each shareholder’s share of income{' '}
                          </TableCell>
                          <TableCell>
                            Includes gains/losses from Schedule D
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Typography variant="body1" sx={{ mb: 4 }}>
                  Learn how S corporations file their main return using{' '}
                  <span style={{ fontWeight: 600 }}>Form 1120-S</span>
                </Typography>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="step"
                >
                  Step-by-Step Breakdown of Schedule D (Form 1120-S)
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Schedule D (Form 1120-S) is used to report an S corporation's
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    capital gains and losses
                  </span>{' '}
                  from the sale or exchange of capital assets. Follow the
                  instructions below to complete each section and report the
                  required information accurately
                </Typography>
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: 600,
                    fontSize: { md: 18, sm: 17, xs: 16 },
                    mb: 0.5,
                  }}
                >
                  Basic Information
                </Typography>
                <picture>
                  <source srcSet="/assets/images/schd-form1120s-basic-img.webp" />
                  <source srcSet="/assets/images/schd-form1120s-basic-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schd-form1120s-basic-img.png"
                    loading="lazy"
                    alt="Schedule D (Form 1120-S) Basic Information section with corporation details and QOF investment disposal"
                    width={760}
                    height={152}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 0.8 }}>
                  Name and Employer Identification Number (EIN)
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the corporation’s legal name and Employer Identification
                  Number (EIN) as shown on Form 1120-S.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 0.8 }}>
                  Qualified Opportunity Fund (QOF) Investment Disposal
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.5 } }}>
                  <li>
                    Check <span style={{ fontWeight: 600 }}> “Yes”</span> if the
                    corporation disposed of any investment in a Qualified
                    Opportunity Fund (QOF) during the tax year.
                  </li>
                  <li>
                    If <span style={{ fontWeight: 600 }}>"Yes"</span>, attach{' '}
                    <span style={{ fontWeight: 600 }}>Form 8949</span> and
                    follow its instructions for reporting the related gain or
                    loss. If no QOF investments were disposed of, check "No".
                  </li>
                </Box>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 0.8 }}>
                  Understand the Four Key Columns
                </Typography>
                <Box component="div" sx={{ mb: 2 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Column
                          </TableCell>

                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Description
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell sx={{ fontWeight: 600 }}>
                            Column (d): Proceeds (Sales Price){' '}
                          </TableCell>
                          <TableCell>
                            {' '}
                            Enter the total amount received from the sale or
                            exchange of the asset.{' '}
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#e6e6e66a' }}>
                          <TableCell sx={{ fontWeight: 600 }}>
                            Column (e): Cost (or Other Basis)
                          </TableCell>
                          <TableCell>
                            {' '}
                            Enter the asset's cost or other adjusted basis used
                            to calculate the gain or loss.
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell sx={{ fontWeight: 600 }}>
                            Column (g): Adjustments
                          </TableCell>
                          <TableCell>
                            {' '}
                            Enter any adjustments to the gain or loss reported
                            on Form 8949, Part I, line 2, column (g), if
                            applicable.
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#e6e6e66a' }}>
                          <TableCell sx={{ fontWeight: 600 }}>
                            Column (h): Gain or (Loss)
                          </TableCell>
                          <TableCell>
                            {' '}
                            Calculate the gain or loss by subtracting column (e)
                            from column (d) and then applying any adjustment
                            from column (g). Enter losses as negative amounts
                            (in parentheses).
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>

                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    mb: 0.5,
                    fontSize: { md: 20, sm: 18, xs: 16 },
                    scrollMarginTop: 83,
                  }}
                  id="part1"
                >
                  Part I: Short-Term Capital Gains and Losses
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Use <span style={{ fontWeight: 600 }}> Part I</span> to report
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    short-term capital gains and losses
                  </span>{' '}
                  from the sale or exchange of capital assets held for{' '}
                  <span style={{ fontWeight: 600 }}>one year or less</span>. If
                  you disposed of an investment in a{' '}
                  <span style={{ fontWeight: 600 }}>
                    Qualified Opportunity Fund (QOF)
                  </span>{' '}
                  during the tax year, answer the question at the top of
                  Schedule D and attach{' '}
                  <span style={{ fontWeight: 600 }}>Form 8949</span> if
                  required.
                </Typography>
                <Alert
                  icon={false}
                  severity="warning"
                  sx={{ mt: 0, mb: 4, borderLeft: '3px solid rgb(102, 60, 0)' }}
                >
                  <b> Note: </b>{' '}
                  <i>
                    Before completing the applicable lines in this section,
                    prepare <span style={{ fontWeight: 600 }}>Form 8949</span>{' '}
                    for any transactions that must be reported there.
                  </i>
                </Alert>
                <picture>
                  <source srcSet="/assets/images/schd-form1120s-part1-img.webp" />
                  <source srcSet="/assets/images/schd-form1120s-part1-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schd-form1120s-part1-img.png"
                    loading="lazy"
                    alt="Schedule D (Form 1120-S) Part I for reporting short-term capital gains and losses on assets held one year or less."
                    width={760}
                    height={372}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 0.8 }}>
                  Line 1a: Transactions Not Reported on Form 8949
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.5 } }}>
                  <li>
                    Enter the total proceeds, cost or other basis, and gain or
                    loss for short-term transactions reported on{' '}
                    <Link
                      href="/resources/information-returns/form-1099-b-instructions/"
                      sx={{ color: '#0202ff' }}
                    >
                      {' '}
                      Form 1099-B
                    </Link>{' '}
                    or{' '}
                    <Link
                      href="/resources/information-returns/form-1099-da-instructions/"
                      sx={{ color: '#0202ff' }}
                    >
                      Form 1099-DA
                    </Link>{' '}
                    when the basis was reported to the IRS and no adjustments
                    are required.
                  </li>
                  <li>
                    If you choose to report these transactions on{' '}
                    <span style={{ fontWeight: 600 }}>Form 8949</span>, leave
                    this line blank and report them on{' '}
                    <span style={{ fontWeight: 600 }}>Line 1b</span> instead.
                  </li>
                </Box>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 0.8 }}>
                  Line 1b: Transactions Reported on Form 8949 (Box A or Box G)
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the totals from{' '}
                  <span style={{ fontWeight: 600 }}>Form 8949</span> for
                  short-term transactions with{' '}
                  <span style={{ fontWeight: 600 }}> Box A</span> or{' '}
                  <span style={{ fontWeight: 600 }}> Box G</span>
                  checked. Transfer the proceeds, basis, adjustments, and gain
                  or loss from Form 8949 to the corresponding columns on this
                  line.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 0.8 }}>
                  Line 2: Transactions Reported on Form 8949 (Box B or Box H)
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the totals from{' '}
                  <span style={{ fontWeight: 600 }}>Form 8949</span> for
                  short-term transactions with{' '}
                  <span style={{ fontWeight: 600 }}>Box B</span> or{' '}
                  <span style={{ fontWeight: 600 }}>Box H</span> checked. Report
                  the amounts exactly as summarized on Form 8949.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 0.8 }}>
                  Line 3: Transactions Reported on Form 8949 (Box C or Box I)
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the totals from{' '}
                  <span style={{ fontWeight: 600 }}>Form 8949</span> for
                  short-term transactions with{' '}
                  <span style={{ fontWeight: 600 }}>Box C</span> or{' '}
                  <span style={{ fontWeight: 600 }}>Box I</span> checked.
                  Include the total proceeds, basis, adjustments, and resulting
                  gain or loss from Form 8949.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 0.8 }}>
                  Line 4: Short-Term Capital Gain from Installment Sales
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the short-term capital gain from{' '}
                  <span style={{ fontWeight: 600 }}>Form 6252</span>, line
                  <span style={{ fontWeight: 600 }}> 26</span> or
                  <span style={{ fontWeight: 600 }}> 37</span>, if applicable.
                  Only include the amount reported on Form 6252.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 0.8 }}>
                  Line 5: Short-Term Capital Gain or Loss from Like-Kind
                  Exchanges
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the short-term capital gain or loss from{' '}
                  <Link
                    href="https://www.irs.gov/pub/irs-pdf/f8824.pdf"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Form 8824
                  </Link>{' '}
                  for any reportable like-kind exchanges completed during the
                  tax year.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 0.8 }}>
                  Line 6: Tax on Short-Term Capital Gain Included on Line 23
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the portion of the{' '}
                  <span style={{ fontWeight: 600 }}> built-in gains tax </span>{' '}
                  attributable to short-term capital gains. Report this amount
                  as a{' '}
                  <span style={{ fontWeight: 600 }}>negative value (loss)</span>{' '}
                  on this line.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 0.8 }}>
                  Line 7: Net Short-Term Capital Gain or Loss
                </Typography>
                <Typography variant="body1" sx={{ mb: 4 }}>
                  Combine the amounts reported in{' '}
                  <span style={{ fontWeight: 600 }}>column (h)</span> on{' '}
                  <span style={{ fontWeight: 600 }}>Lines 1a through 6</span> to
                  determine your net short-term capital gain or loss. Enter the
                  result on this line and report it on{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Form 1120-S, Schedule K
                  </span>
                  , as instructed.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    mb: 0.5,
                    fontSize: { md: 20, sm: 18, xs: 16 },
                    scrollMarginTop: 83,
                  }}
                  id="part2"
                >
                  Part II: Long-Term Capital Gains and Losses
                </Typography>
                <Typography variant="body1">
                  Part II is used to report{' '}
                  <span style={{ fontWeight: 600 }}>
                    long-term capital gains and losses
                  </span>{' '}
                  from assets held for more than one year. Enter transaction
                  details from{' '}
                  <span style={{ fontWeight: 600 }}>
                    Form 8949, Form 1099-B, Form 1099-DA, or other applicable
                    forms
                  </span>
                  . Round amounts to whole dollars if preferred.
                </Typography>
                <picture>
                  <source srcSet="/assets/images/schd-form1120s-part2-img.webp" />
                  <source srcSet="/assets/images/schd-form1120s-part2-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schd-form1120s-part2-img.png"
                    loading="lazy"
                    alt="Schedule D (Form 1120-S) Part II for reporting long-term capital gains and losses on assets held more than one year."
                    width={760}
                    height={386}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 0.8 }}>
                  Line 8a: Transactions Reported on Form 1099-B or Form 1099-DA
                  (Basis Reported to IRS)
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.5 } }}>
                  <li>
                    Enter the totals for long-term transactions reported on Form
                    1099-B or Form 1099-DA where the basis was reported to the
                    IRS and no adjustments apply.
                  </li>
                  <li>
                    If these transactions are instead reported on Form 8949,
                    please leave this line blank.
                  </li>
                </Box>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 0.8 }}>
                  Line 8b: Transactions Reported on Form 8949 (Box D or Box J)
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the totals from Form 8949 for long-term transactions
                  with Box D or Box J checked. Report the proceeds, basis,
                  adjustments, and gain or loss as shown on Form 8949.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 0.8 }}>
                  Line 9: Transactions Reported on Form 8949 (Box E or Box K)
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the totals from Form 8949 for long-term transactions
                  with Box E or Box K checked. Include the total proceeds,
                  basis, adjustments, and resulting gain or loss from Form 8949.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 0.8 }}>
                  Line 10: Transactions Reported on Form 8949 (Box F or Box L)
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the totals from Form 8949 for long-term transactions
                  with Box F or Box L checked. Include the total proceeds,
                  basis, adjustments, and resulting gain or loss from Form 8949.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 0.8 }}>
                  Line 11: Long-Term Capital Gain From Installment Sales
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the long-term capital gain from installment sales
                  reported on Form 6252, line 26 or 37, if applicable. Only
                  include the amount reported on Form 6252.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 0.8 }}>
                  Line 12: Long-Term Capital Gain or Loss From Like-Kind
                  Exchanges
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the long-term capital gain or loss from Form 8824 for
                  any reportable like-kind exchanges completed during the tax
                  year.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 0.8 }}>
                  Line 12: Long-Term Capital Gain or Loss From Like-Kind
                  Exchanges
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the long-term capital gain or loss from Form 8824 for
                  any reportable like-kind exchanges completed during the tax
                  year.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 0.8 }}>
                  Line 13: Capital Gain Distributions
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter capital gain distributions received during the tax year
                  as reported in the instructions.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 0.8 }}>
                  Line 14: Tax on Long-Term Capital Gain Included on Line 23
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the portion of the built-in gains tax related to
                  long-term capital gains included on Line 23. Report this
                  amount as a negative value (loss) on this line.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 0.8 }}>
                  Line 15: Net Long-Term Capital Gain or Loss
                </Typography>
                <Typography variant="body1" sx={{ mb: 4 }}>
                  Combine the amounts reported in column (h) on Lines 8a through
                  14 to determine your net long-term capital gain or loss. Enter
                  the result on this line and report it on Form 1120-S, Schedule
                  K, as instructed.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    mb: 0.5,
                    fontSize: { md: 20, sm: 18, xs: 16 },
                    scrollMarginTop: 83,
                  }}
                  id="part3"
                >
                  Part III: Built-in Gains Tax
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Part III is used to calculate the{' '}
                  <span style={{ fontWeight: 600 }}>built-in gains tax</span>{' '}
                  that may apply to an S corporation that was previously a C
                  corporation. Complete this section only if the corporation has{' '}
                  <span style={{ fontWeight: 600 }}>
                    recognized built-in gains or losses
                  </span>
                  subject to Section 1374 rules.
                </Typography>
                <picture>
                  <source srcSet="/assets/images/schd-form1120s-part3-img.webp" />
                  <source srcSet="/assets/images/schd-form1120s-part3-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schd-form1120s-part3-img.png"
                    loading="lazy"
                    alt="Schedule D (Form 1120-S) Part III for calculating the built-in gains tax for S corporations."
                    width={760}
                    height={197}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 0.8 }}>
                  Line 16: Excess of Recognized Built-in Gains Over Recognized
                  Built-in Losses
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the excess of recognized built-in gains over recognized
                  built-in losses. Attach the required computation statement
                  showing how the amount was calculated.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 0.8 }}>
                  Line 17: Taxable Income
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the corporation’s taxable income. Attach the required
                  computation statement supporting the amount reported.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 0.8 }}>
                  Line 18: Net Recognized Built-in Gain
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the smallest amount from{' '}
                  <span style={{ fontWeight: 600 }}>
                    Line 16, Line 17, or Schedule B, Line 8.
                  </span>{' '}
                  This amount represents the net recognized built-in gain
                  subject to tax.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 0.8 }}>
                  Line 19: Section 1374(b)(2) Deduction
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the allowable deduction under{' '}
                  <span style={{ fontWeight: 600 }}>Section 1374(b)(2)</span>,
                  if applicable.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 0.8 }}>
                  Line 20: Net Taxable Built-in Gain
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Subtract{' '}
                  <span style={{ fontWeight: 600 }}>Line 19 from Line 18</span>.
                  If the result is zero or less, enter 0 on this line and Line
                  23.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 0.8 }}>
                  Line 21: Tax on Net Recognized Built-in Gain
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Multiply the amount on{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Line 20 by 21% (0.21)
                  </span>{' '}
                  to calculate the built-in gains tax before credits.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 0.8 }}>
                  Line 22: Business Credit and Minimum Tax Credit Carryforwards
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter any available{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Section 1374(b)(3) business credit and minimum tax credit
                    carryforwards
                  </span>{' '}
                  from the corporation’s C corporation years.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 0.8 }}>
                  Line 23: Built-in Gains Tax
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Subtract{' '}
                  <span style={{ fontWeight: 600 }}> Line 22 from Line 21</span>
                  . If the result is zero or less, enter{' '}
                  <span style={{ fontWeight: 600 }}> 0</span> Report the final
                  amount here and on{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Form 1120-S, page 1, line 23b.
                  </span>
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="filing"
                >
                  Filing Deadline for Schedule D
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Schedule D must be filed along with{' '}
                  <span style={{ fontWeight: 600 }}>Form 1120-S</span> by the{' '}
                  <span style={{ fontWeight: 600 }}>
                    S corporation filing deadline:{' '}
                  </span>
                </Typography>

                <Box component="div" sx={{ mb: 2 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Entity Type
                          </TableCell>

                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Main Return
                          </TableCell>
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Filing Deadline (Tax Year 2025)
                          </TableCell>
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Extension Form
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell>S Corporation </TableCell>
                          <TableCell> Form 1120-S</TableCell>
                          <TableCell>March 16, 2026</TableCell>
                          <TableCell>
                            <Link
                              href="/tax-extension/efile-irs-form-7004-business-tax-extension-online/"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              Form 7004
                            </Link>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Typography variant="body1" sx={{ mb: 4 }}>
                  Learn how to extend your S corporation filing deadline using{' '}
                  <span style={{ fontWeight: 600 }}> Form 7004</span>
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="common"
                >
                  Common Mistakes to Avoid
                </Typography>
                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Common Mistakes
                          </TableCell>

                          <TableCell
                            sx={{ color: '#444', width: 200, fontWeight: 600 }}
                          >
                            Impact
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell>
                            Failing to report short-term and long-term
                            transactions separately
                          </TableCell>
                          <TableCell>Incorrect tax treatment </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>
                            Not transferring data correctly from Form 8949
                          </TableCell>
                          <TableCell>
                            Inaccurate totals on Schedule D{' '}
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>
                            Ignoring built-in gains tax rules
                          </TableCell>
                          <TableCell>Underreported liability </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>
                            Forgetting to attach Schedule D to Form 1120-S
                          </TableCell>
                          <TableCell>
                            Return rejection or processing delay
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>
                            Misreporting capital loss carryovers
                          </TableCell>
                          <TableCell>Loss of valuable deductions</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="best"
                >
                  Best Practices for Compliance
                </Typography>

                <Box component="ul" sx={{ '& li': { mb: 1.5 }, mb: 4 }}>
                  <li>
                    Maintain detailed transaction records (purchase, sale, and
                    holding periods).
                  </li>
                  <li>
                    Reconcile totals between{' '}
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Form 8949, Form 4797,{' '}
                    </span>{' '}
                    and <span style={{ fontWeight: 600 }}>Schedule D.</span>
                  </li>
                  <li>Track carryover losses accurately for future years.</li>

                  <li>
                    Use{' '}
                    <span style={{ fontWeight: 600 }}>
                      TaxZerone’s guided e-filing
                    </span>{' '}
                    to automatically attach Schedule D and ensure accurate
                    calculations.
                  </li>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="faqs"
                >
                  Frequently Asked Questions (FAQs)
                </Typography>

                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  1. What is the purpose of Schedule D (Form 1120-S)?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  It reports the S corporation’s capital gains, losses, and
                  built-in gains, ensuring accurate pass-through reporting to
                  shareholders.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  2. What’s the difference between short-term and long-term
                  capital gains?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Short-term gains are from assets held for{' '}
                  <span style={{ fontWeight: 600 }}> one year or less,</span>
                  while long-term gains are from assets held for{' '}
                  <span style={{ fontWeight: 600 }}>more than one year.</span>
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  3. How are capital gains distributed to shareholders?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  They flow through the S corporation return to{' '}
                  <span style={{ fontWeight: 600 }}>Schedule K,</span> then to
                  each shareholder’s{' '}
                  <span style={{ fontWeight: 600 }}>
                    Schedule K-1 (Form 1120-S).
                  </span>
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  4. What is built-in gains tax for S corporations?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  It applies when a former C corporation converts to an S
                  corporation and sells appreciated assets within the
                  recognition period.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  5. Can Schedule D be e-filed?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Yes, it can be e-filed with{' '}
                  <span style={{ fontWeight: 600 }}>Form 1120-S</span> through
                  authorized e-file providers like{' '}
                  <span style={{ fontWeight: 600 }}>TaxZerone.</span>
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Container maxWidth="lg" sx={{ mb: 5, my: { xs: 6, sm: 6, md: 6 } }}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={{ xs: 2, md: 5 }}
        >
          <Box
            sx={{
              width: '100%',
              textAlign: 'center',
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 2,
                textAlign: 'center',
                lineHeight: 1.5,
              }}
            >
              E-File Your Form 1120-S with Schedule D Using TaxZerone
            </Typography>

            <Typography
              variant="h3"
              sx={{
                fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                fontWeight: 400,
                color: '#333333',
                mb: 3,
              }}
            >
              Ensure your S corporation’s capital gains and losses are reported
              accurately.
            </Typography>

            <Box sx={{ textAlign: { xs: 'center', md: 'center' } }}>
              <Button
                variant="contained"
                sx={{
                  mt: 1,
                  transition: 'all 0.3s ease 0s',
                  '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                }}
                className="btn-primary"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=1120sschd`}
              >
                Start Filing Now
              </Button>
            </Box>
          </Box>
        </Stack>
      </Container>
    </AppLayout>
  );
};

export default Form1120sSchD;
